import { render } from "./invite.vue?vue&type=template&id=fd8bd00a&ts=true"
import script from "./invite.vue?vue&type=script&lang=ts"
export * from "./invite.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__